import {Header, Layout} from "@components/common";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {fetchJson, getShopNavigation, redirectTo404Page} from "../index";
import {useState} from "react";
import delve from "dlv";
import Link from "next/link";
import s from "./riders.module.scss";
import Image from "next/image";
import {getStrapiMedia} from "@utils/strapi";
import cn from "clsx";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";

export function getRiders(tag: string | null = null, U19 = false) {
  return new Promise(async (resolve) => {
    let url = `${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/api/riders?populate=*&pagination[page]=1&pagination[pageSize]=100`;
    if (U19) {
      url += '&filters[$and][0][Tags][$containsi]=' + 'U19'
    } else {
      url += '&filters[$and][0][Tags][$notContainsi]=' + 'U19'
    }

    if (tag) {
      url += '&filters[$and][1][Tags][$containsi]=' + tag;
    }
    const riders: any = await fetchJson(
      url,
      'data'
    );
    resolve(riders);
  });
}

export async function getServerSideProps(context: any) {
  try {
    const {locale, query} = context;
    const riders = await getRiders(query?.category);
    return {
      props: {
        ...(await serverSideTranslations(locale, ["common", "home"])),
        ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
        U19: false,
        riders,
        locale
      }
    };
  } catch (error) {
    console.error(error)
    return redirectTo404Page();
  }
}

function getFlagEmoji(countryCode: string) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    /* @ts-ignore */
    .map(char => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

export default function Riders(data: any) {
  const { t } = useTranslation("common");
  const router = useRouter();
  const query = router.query;
  const [activeFilter, setActiveFilter] = useState(query?.category ?? '');
  const [toggleFilter, setToggleFilter] = useState(false)
  let [riders, setRiders] = useState(data.riders);
  let [locale, setLocale] = useState(data.locale);
  let [U19, setU19] = useState(data.U19);
  const categories = [
    "Climber",
    "Sprinter",
    "Time Trialist",
    "Allrounded",
    "GC",
    "Classics",
  ];

  const handleClickDropdown = (event: any, filter: string) => {
    if (filter !== activeFilter) {
      console.log("test 1", event);
      setToggleFilter(true)
    } else {
      console.log("test 2", event);
      setToggleFilter(!toggleFilter)
    }
    setActiveFilter(filter)
  }

  const handleClick = async (event: any, filter: any) => {
    if (filter !== activeFilter) {
      setToggleFilter(true)
    } else {
      setToggleFilter(!toggleFilter)
      filter = '';
    }
    setActiveFilter(filter);
    const res = await getRiders(filter, U19 === true)
    setRiders(res);
  }

  return (
    <>
      <div className="container-rg">
        <Header></Header>
        <header>
          <h1 className="mb-4">{t("riders").toUpperCase()} {
            U19 ? 'U19' : null
          }</h1>
          <Image
            src="/assets/Header_01.jpg"
            alt="Header image"
            width={1200}
            height={500}
            priority={false}
            quality="100"
          />
        </header>
        <div className={s.body}>
          <nav>
            <div className="relative inline-block w-full">
              <div className="lg:hidden">
              <span className="rounded-md shadow-sm">
                <button
                  type="button"
                  onClick={(e) => handleClickDropdown(e, 'categories')}
                  className="flex justify-between w-full rounded-sm border border-accent-3 px-4 py-3 bg-accent-0 text-sm leading-5 font-medium text-accent-4 hover:text-accent-5 focus:outline-none focus:border-blue-300 focus:shadow-outline-normal active:bg-accent-1 active:text-accent-8 transition ease-in-out duration-150"
                  id="options-menu"
                  aria-haspopup="true"
                  aria-expanded="true"
                >
                  {activeFilter
                    ? `Category: ${activeFilter}`
                    :  t("all-categories") }
                  <svg
                    className="-mr-1 ml-2 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </span>
              </div>
              <div
                className={`origin-top-left absolute lg:relative left-0 mt-2 w-full rounded-md shadow-lg lg:shadow-none z-10 mb-10 lg:block ${
                  activeFilter !== 'categories' || toggleFilter !== true
                    ? 'hidden'
                    : ''
                }`}
              >
                <div className="rounded-sm bg-accent-0 shadow-xs lg:bg-none lg:shadow-none">
                  <div
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="options-menu"
                  >
                    <ul>
                      <li
                        className={cn(
                          'block text-sm leading-5 text-accent-4 lg:text-base lg:no-underline lg:font-bold lg:tracking-wide hover:bg-accent-1 lg:hover:bg-transparent hover:text-accent-8 focus:outline-none focus:bg-accent-1 focus:text-accent-8',
                          {
                            underline: !activeFilter,
                          }
                        )}
                      >
                        <Link legacyBehavior
                              href={{ pathname: '' }}
                        >
                          <a
                            onClick={(e) => handleClick(e, null)}
                            className={
                              'block lg:inline-block px-4 py-2 lg:p-0 lg:my-2 lg:mx-4'
                            }
                          >
                            {t("all-categories")}
                          </a>
                        </Link>
                      </li>
                      {categories.map((cat: any) => (
                        <li
                          key={cat}
                          className={cn(
                            'block text-sm leading-5 text-accent-4 hover:bg-accent-1 lg:hover:bg-transparent hover:text-accent-8 focus:outline-none focus:bg-accent-1 focus:text-accent-8',
                            {
                              underline: activeFilter === cat,
                            }
                          )}
                        >
                          <Link legacyBehavior
                                href={{
                                  pathname: '',
                                }}
                          >
                            <a
                              onClick={(e) => handleClick(e, cat)}
                              className={
                                'block lg:inline-block px-4 py-2 lg:p-0 lg:my-2 lg:mx-4'
                              }
                            >
                              {cat}
                            </a>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <main>
            {
              riders?.map((rider: any, index: any) => {
                return (
                  <Link legacyBehavior key={index} href={`${router.asPath}/${delve(rider, 'attributes.Slug')}`}>
                    <div className={s.rider}>
                      {
                        rider?.attributes?.Country && <span className={s.flag}>{getFlagEmoji(delve(rider, 'attributes.Country'))}</span>
                      }
                      <Image
                        className="object-contain"
                        src={getStrapiMedia(delve(rider, 'attributes.Image.data.attributes.url')) || ""}
                        alt={delve(rider, 'attributes.Image.data.attributes.alternativeText') || ""}
                        width={400}
                        height={400}
                        priority={false}
                        quality="85"
                      />
                      <p className={s.tags}>
                      {
                        rider.attributes.Tags?.length > 0 ?

                          rider.attributes.Tags.map((tag: string, index: number) => {
                            return (<span key={index}>
                              {index !== 0 ? <></> : null}{tag}
                            </span>);
                          }) : null
                      }
                      </p>
                      <div className={s.card}>
                        <h4>{delve(rider, 'attributes.Name')}</h4>
                        <div className="text-right">
                          <Link legacyBehavior key={index} href={`${router.asPath}/${delve(rider, 'attributes.Slug')}`}>
                            <a className="brand-link text-sm mr-4">{t("readmore")}</a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Link>
                )
              })
            }
          </main>
        </div>
      </div>
    </>
  )
}

Riders.Layout = Layout
